import { Alert } from '@mui/material';
import type { FC } from 'react';

export const NoLocation: FC = () => (
  <Alert severity="info">Event location not set.</Alert>
);
